import script from "./EbooksListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EbooksListView.vue?vue&type=script&setup=true&lang=ts"

import "./EbooksListView.css?vue&type=style&index=0&id=bfb3773c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfb3773c"]])

export default __exports__